export interface DebugEntry {
    id: string;
    request: string;
    path: string;
    url: string;
    duration: string;
    description: string;
}

export interface DebugState {
    entries: DebugEntry[];
}

const MAX_DEBUG_ENTRIES = 3;

const initialDebugState: DebugState = { entries: [] };

function extractDebug(action: any): DebugEntry | null {
    const debug = action?.response?.debug || action?.response?.result?.debug;
    if (!debug || !debug.path) {
        return null;
    }
    return {
        id: debug.id,
        request: debug.request,
        path: debug.path,
        url: debug.url,
        duration: debug.duration,
        description: debug.description,
    };
}

export function debugReducer(state: DebugState = initialDebugState, action: any): DebugState {
    const entry = extractDebug(action);
    if (!entry) {
        return state;
    }
    return {
        entries: [entry, ...state.entries.slice(0, MAX_DEBUG_ENTRIES - 1)],
    };
}
